import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import Amplify from '@aws-amplify/core';

Amplify.configure({
  Auth: {
    mandatorySignId: true,
    region: 'eu-west-1',
    // Dev
    // userPoolId: 'eu-west-1_fGaQaBbeC',
    // userPoolWebClientId: '16vkgtdasqrrhpkkgmm04gf8se'
    // Prod userpool
    userPoolId: 'eu-west-1_vTXmSPVDc',
    userPoolWebClientId: '3mv1bpfal4ucf701ncf1uemnc7'
  }
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts